import * as React from 'react';

export const ErrorPage = (): JSX.Element => {
	return (
		<div className="servicios-home">
			<h3>No se ha encontrado la página que esta buscando.</h3>
		</div>
	);
};
